import { QueryParamsType } from "src/types/query-params";
import { useSwrRequest } from "../useSwrRequest";
import qs from "qs";
import useRequest from "../useRequest";

export const useBrands = (query: Record<string, QueryParamsType>) => {
  const url = `/brands?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
  return {
    brands: (data as Array<any>) || [],
    mutate,
    isLoading,
    error,
    ...rest,
  };
};
